import { render, staticRenderFns } from "./Make.vue?vue&type=template&id=16cf510c&scoped=true&"
import script from "./Make.vue?vue&type=script&lang=js&"
export * from "./Make.vue?vue&type=script&lang=js&"
import style0 from "./Make.vue?vue&type=style&index=0&id=16cf510c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cf510c",
  null
  
)

export default component.exports